interface AdminProps {
    
}
 
const Admin: React.FC<AdminProps> = () => {
    return (<h1>Admin</h1>);
}
 
export default Admin;